// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__28wB4","amount":"Amount_amount__3v9dw","tip":"Amount_tip__2EHbL","tipHeader":"Amount_tipHeader__7ot_r","tipsWrap":"Amount_tipsWrap__1bsTp"};